import { render, staticRenderFns } from "./IntegrationsTab.vue?vue&type=template&id=80d9a36c&scoped=true&"
import script from "./IntegrationsTab.vue?vue&type=script&lang=js&"
export * from "./IntegrationsTab.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsTab.vue?vue&type=style&index=0&id=80d9a36c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d9a36c",
  null
  
)

export default component.exports